export const API2_BASE_URL = import.meta.env.VITE_API2_BASE_URL;

export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

export const SENTRY_DNS = import.meta.env.VITE_SENTRY_DNS;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT;

// HubSpot portal/account ID used to build deep links into the CRM. Differs per
// environment (prod vs QA HubSpot account); falls back to prod if unset.
export const HUBSPOT_PORTAL_ID = import.meta.env.VITE_HUBSPOT_PORTAL_ID ?? '26782564';

// This is a GCP-managed map ID for the Google Maps API that controls the properties of the map,
export const GOOGLE_MAPS_MAP_ID_ADMI_MAP = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID_ADMI_MAP as string;

export const IS_DEV = import.meta.env.DEV; // build-in vite variable
